export default __webpack_public_path__ + "static/media/dinner.da19b080.svg";